import React, { useState } from "react";
import styles from "./styles.module.scss";

function JeansPant() {
  const [glbView, setGlbView] = useState(false);
  const [mobileGlb, setMobileGlb] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [desktopAr, setDesktopAr] = useState(false);
  const [mobileAr, setMobileAr] = useState(false);

  const [imageView, setImageView] = useState(true);

  const toggleDesktopAR = () => {
    setDesktopAr(!desktopAr);
    setGlbView(false);
    setMobileGlb(false);
    setImageView(!imageView);
  };

  const toggleMobileAR = () => {
    setMobileAr(!mobileAr);
    setGlbView(false);
    setMobileGlb(false);
    setImageView(!imageView);
  };

  const [selectedImage, setSelectedImage] = useState(
    "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_1.webp"
  );

  const toggleMobileglb = () => {
    setMobileGlb(!mobileGlb);
    setImageView(!imageView);
    setShowVideo(false);
  };

  const handleImageClick = (imageSrc) => {
    setGlbView(false);
    setShowVideo(false);
    setMobileGlb(false);
    setMobileAr(false);
    setDesktopAr(false);
    setSelectedImage(imageSrc);
    setImageView(true);
  };

  return (
    <div>
      <div className={styles.container}>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/mobile_header.webp"
          alt=""
        />

        <div className={styles.renderSection}>
          <p onClick={toggleMobileAR}>Try Before Buy</p>
          {mobileGlb && (
            <iframe
              title="mobileGlb"
              src="https://www.pod.advflr.com/turnaround/urbanoutfitters/bella_baggy_jean"
            ></iframe>
          )}

          {mobileAr && (
            <iframe
              title="mobileAr"
              src="https://www.pod.advflr.com/client/vto/frontcamera/47fbf7d8-2688-4465-80bc-a6f54d416544/1ee15629-39c0-4eb9-849b-8dabd1a6729f"
            ></iframe>
          )}

          {imageView && <img src={selectedImage} alt="" />}
        </div>

        <div className={styles.thumbnailSection}>
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_1.webp"
            alt=""
            onClick={() =>
              handleImageClick(
                "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_1.webp"
              )
            }
          />
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_2.webp"
            alt=""
            onClick={() =>
              handleImageClick(
                "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_2.webp"
              )
            }
          />

          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/360_thumbnai.webp"
            onClick={toggleMobileglb}
            alt=""
          />
        </div>

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/mobile_likable.webp"
          alt=""
        />

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/baseball-hat/mobile_footer.webp"
          alt=""
        />
      </div>

      <div className={styles.desktopContainer}>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/baseball-hat/header.webp"
          alt=""
        />

        <div className={styles.mainContainer}>
          <div className={styles.renderSection} style={{ marginTop: "1rem" }}>
            <p onClick={toggleDesktopAR}>Try Before Buy</p>
            {mobileGlb && (
              <iframe
                title="mobileGlb"
                src="https://www.pod.advflr.com/turnaround/urbanoutfitters/bella_baggy_jean"
              ></iframe>
            )}
            {desktopAr && (
              <iframe
                title="desktopAR"
                src="https://www.pod.advflr.com/client/vto/frontcamera/47fbf7d8-2688-4465-80bc-a6f54d416544/1ee15629-39c0-4eb9-849b-8dabd1a6729f"
              ></iframe>
            )}
            {showVideo && (
              <video
                className={styles.videoSection}
                autoPlay
                src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/dowel-counter-stool/video_preview.mp4"
              ></video>
            )}
            {imageView && <img src={selectedImage} alt="" />}
          </div>

          <div className={styles.cartSection}>
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/details_1.webp"
              alt=""
            />
          </div>
        </div>

        <div className={styles.thumbnailSection}>
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_1.webp"
            alt=""
            onClick={() =>
              handleImageClick(
                "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_1.webp"
              )
            }
          />
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_2.webp"
            alt=""
            onClick={() =>
              handleImageClick(
                "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/render_2.webp"
              )
            }
          />
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/360_thumbnai.webp"
            onClick={toggleMobileglb}
            alt=""
          />
        </div>

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jeans/likable.webp"
          alt=""
        />

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/baseball-hat/footer.webp"
          alt=""
        />
      </div>
    </div>
  );
}

export default JeansPant;
